import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import React, { useContext } from "react";
import { FaSpinner } from "react-icons/fa";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-white">
        <FaSpinner className="animate-spin text-4xl" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
